import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const EditIcon = ({
  title = 'Edit',
  className = 'edit-icon',
  viewBox = '0 0 16 16',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} className={className} viewBox={viewBox} {...props}>
    <path
      fillRule="evenodd"
      d="M14.645 1.535a3.659 3.659 0 010 5.176l-8.493 8.492a.715.715 0 01-.43.211l-4.706.566a.734.734 0 01-.813-.816l.567-4.707a.755.755 0 01.207-.43l8.492-8.492a3.659 3.659 0 015.176 0zM4.91 11.211l-2.66-.387-.059.063-.421 3.527 3.527-.422.016-.015zm7.149-3.98L8.953 4.124l-5.41 5.406 2.121.309c.297.043.54.265.606.558l.011.063.324 2.223zm1.55-4.66a2.2 2.2 0 00-3.105 0l-.516.519 3.106 3.105.515-.52c.84-.835.86-2.183.059-3.046zm0 0"
    />
  </CreateIconComponent>
);

export default EditIcon;
